import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { extendBannerContentStylesheet, extendCommonContentStylesheet } from "@devowl-wp/web-cookie-banner";
import { BannerCloseIcon } from "./closeIcon.js";
import { useBanner } from "../../../contexts/banner.js";
import { useBannerStylesheet } from "../../../hooks/banner/useBannerStylesheet.js";
const BannerHeader = /*#__PURE__*/ forwardRef(({ className }, ref)=>{
    const stylesheet = useBannerStylesheet();
    const { a11yIds, HeaderContainer, hasCloseIcon, HeaderTitle } = stylesheet.extend(...extendBannerContentStylesheet).extend(...extendCommonContentStylesheet);
    const { headerDesign: { logo, logoRetina, logoAlt }, decision: { showCloseIcon }, texts: { headline }, activeAction, individualPrivacyOpen, individualTexts, i18n: { headerTitlePrivacyPolicyHistory } } = useBanner();
    // Calculate logo
    const useRetina = logoRetina && !logo?.endsWith(".svg") && window.devicePixelRatio > 1;
    const useLogo = useRetina ? logoRetina : logo;
    // Calculate headline
    const useCloseIcon = !!showCloseIcon || !!activeAction;
    const useHeadline = individualPrivacyOpen ? activeAction === "history" ? headerTitlePrivacyPolicyHistory : individualTexts.headline : headline;
    return /*#__PURE__*/ _jsx(HeaderContainer, {
        ref: ref,
        className: className,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                !!useLogo && /*#__PURE__*/ _jsx("img", {
                    "aria-hidden": true,
                    alt: logoAlt || "",
                    src: useLogo
                }),
                !!useHeadline && /*#__PURE__*/ _jsx(HeaderTitle, {
                    id: a11yIds.headline,
                    className: useCloseIcon ? hasCloseIcon : undefined,
                    children: useHeadline
                }),
                useCloseIcon && /*#__PURE__*/ _jsx(BannerCloseIcon, {})
            ]
        })
    });
});
export { BannerHeader };
